import {Directive, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {Address, Quote, QuoteRequest, QuoteState} from '../../model/quote';
import {QuoteBarItem} from '../../model/quote-bar-item';

@Directive()
export abstract class AbstractQuoteComponent {
    abstract deleteQuoteMessageTextId;
    private _quoteBarItem: QuoteBarItem;

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    @Input()
    set quoteBarItem(quoteBarItem: QuoteBarItem) {
        this._quoteBarItem = quoteBarItem;

        this.onQuoteBarItemChanged();
    }

    @Output()
    deleteQuote = new EventEmitter<Quote>();

    protected dialogWidthPx = 350;
    protected abstract dialog: MatDialog;

    get quoteBarItem(): QuoteBarItem {
        return this._quoteBarItem;
    }

    get quote(): Quote {
        return this.quoteBarItem.quote;
    }

    get request(): QuoteRequest {
        return this.quote.request;
    }

    get hasRequestData(): boolean {
        return this.request != null;
    }

    get requestAddress(): Address {
        if (this.hasRequestData) {
            return this.request.address;
        }
        return null;
    }

    get isPending(): boolean {
        return this.quoteBarItem.isPending;
    }

    get isMutable(): boolean {
        return this.quote.state === QuoteState.NEW;
    }

    openDeleteConfirmationDialog(event: Event): void {
        if (event) {
            event.stopPropagation();
        }

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: `${this.dialogWidthPx}px`,
            data: {
                subheader: this.quote.name,
                message: this.i18nDictionary.get(this.deleteQuoteMessageTextId)
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.deleteQuote.emit(this.quote);
            }
        });
    }

    protected onQuoteBarItemChanged(): void {
        // default implementation empty, change it in the subclass.
    }
}
